import { Injectable } from '@angular/core';

import { CoverageRange } from "../models";
import { CustomFormControl } from "digital-core";
import { CurrencyService } from "../services";

@Injectable({
  providedIn: 'root'
})
export class RangeValidator {
    constructor(
      private currencyService: CurrencyService
    ) {

    }

    isCurrencyWithinRange(coverage: CoverageRange, component: CustomFormControl) {
      if (!component.value) {
        return { required: { valid: false } };
      }        

      let val = this.currencyService.reverseFormatNumber(component.value);
  
      if (coverage && val < coverage.Min || val > coverage.Max) {
        return { valueRange: true };
      } else {
        return null;
      }
    }

    isPriceWithinRange(coverage: CoverageRange, component: CustomFormControl) {
      if (!component.value) {
        return { required: { valid: false } };
      }        

      let val = component.value;
  
      if (coverage && val < coverage.Min || val > coverage.Max) {
        return { valueRange: true };
      } else {
        return null;
      }
    }

    isValueWithinRange(coverage: CoverageRange, component: CustomFormControl) {
        if (!component.value) {
          return { required: { valid: false } };
        }        

        let val = +component.value.toString().replace(/,/g, "");
    
        if (coverage && val < coverage.Min || val > coverage.Max) {
          return { weightRange: true };
        } else {
          return null;
        }
      }
}
